import React, { useState, useEffect } from "react";
import { ProductCard } from "./ProductCard";
import serviceimag1 from "../assets/img/Picture1.jpg";
import serviceimag2 from "../assets/img/Picture2.jpg";
import serviceimag3 from "../assets/img/Picture3.jpg";
import serviceimag4 from "../assets/img/Picture4.jpg";
import serviceimag5 from "../assets/img/Picture5.jpg";
import serviceimag6 from "../assets/img/Picture6.jpg";
import serviceimag7 from "../assets/img/Picture7.jpg";
import serviceimag8 from "../assets/img/Picture8.jpg";
import serviceimag9 from "../assets/img/Picture9.jpg";
import serviceimag10 from "../assets/img/Picture10.jpg";
import serviceimag11 from "../assets/img/Picture11.jpg";
import serviceimag12 from "../assets/img/Picture12.jpg";
export const servicesdata = [
  {
    id: 1,
    serviceimage: serviceimag1,
    cardtitle: "Bold Peanuts",
    title: "Bold Peanuts",
    description: "Premium quality Bold Peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",

      Origin: "India",
      Count: "38/42 , 40/50 , 50/60 & 60/70",
      Cleaning: "Sortex Cleaned",
      Moisture: "8% max",
      Admixture: "1% max",
      Foreignmaterial: "0.5%max",
      Brokenandsplits: "1%max",
      Oilcontent: "48-52%",
      Packing: "25/50kg Jute bag , pp bag , vacuum bag",
    },
    image: serviceimag1,
    servicelink: "/peanuts"
  },
  {
    id: 2,
    serviceimage: serviceimag2,
    cardtitle: "Java Peanut",
    title: "Java Peanut",
    description: "High-quality Java Peanuts, perfect for cooking.",
    specifications: {
      Type: "Fresh Onion",
      Minquantity: "28000 kg",
      Origin: "India",

      Packing: "25/50 kg in jute bag , pp bag or vacuum bag",
      Count: "40/50, 50/60, 60/70, 70/80, 80/90",
      Cleaning: "Sortex Cleaned",
      Moisture: "8% max",
      Admixture: "1% max",
      Foreignmaterial: "0.5%max",
      Brokenandsplits: "1%max",
    
    },
    image: serviceimag2,
    servicelink: "/peanuts"
  },
  {
    id: 3,
    serviceimage: serviceimag3,
    cardtitle: "TJ Peanut",
    title: "TJ Peanut",
    description: "Premium quality TJ Peanut for various uses.",
    specifications: {
      Type: "TJ Peanut",
      Origin: "India",
      Packing: "25/50 kg in jute bag , pp bag or vacuum bag",
      Count: "50/60 & 80/90",
      Cleaning: "Sortex Cleaned",
      Moisture: "8% max",
      Admixture: "1% max",
      Foreignmaterial: "0.5%max",
    },
    image: serviceimag3,
    servicelink: "/peanuts"
  },
  {
    id: 4,
    serviceimage: serviceimag4,
    cardtitle: "Roasted Blanched Peanuts",
    title: "Roasted Blanched Peanuts",
    description: "Premium quality Roasted Blanched Peanuts for various uses.",
    specifications: {
      Type: "Roasted Blanched Peanuts",
      Origin: "India",
      Packing: "vacuum or pp bag",
      Count: "38/42 , 40/50 , 50/60",
      Color: "Creaming White / Brown",
      Cleaning: "Sortex Cleaned",
      Moisture: "4% max",
      Splits: "1% max",
      Admixture: "1% max",
    },
    image: serviceimag4,
    servicelink: "/peanuts"
  },
  {
    id: 5,
    serviceimage: serviceimag5,
    cardtitle: "Peanut split (Raw/Blanched)",
    title: "Peanut split (Raw/Blanched)",
    description: "Premium quality Peanut split (Raw/Blanched) for various uses.",
    specifications: {
      Type: "Peanut split (Raw/Blanched)",
      Origin: "India",
      cultivationType: "natural",
      Size: "40/50, 50/60",
      RedSkin: "5 % Max",
      Packing: "25/50kg pp bag or vacuum bag",
    },
    image: serviceimag5,
    servicelink: "/peanuts"
  },
  {
    id: 6,
    serviceimage: serviceimag8,
    cardtitle: "Psyllium Husk and Powder",
    title: "Psyllium Husk and Powder",
    description: "Premium quality Psyllium Husk and Powder for various uses.",
    specifications: {
      Color: "brown",
      Type: "Psyllium Husk and Powder",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      Minquantity: "1000 kg",
      uses: "Human Consumption",
      Origin: "India",

      Packing: "25 kg pp bag",
    },
    image: serviceimag8,
    servicelink: "/psylliumhusk"
  },
  {
    id: 7,
    serviceimage: serviceimag9,
    cardtitle: "Pink Onion",
    title: "Pink Onion",
    description: "Premium quality Pink Onion for various uses.",
    specifications: {
      Type: "Pink Onion",
      Color: "brown/creamy",

      Packing: "10/20kg Jute bag",
      Minquantity: "1000 kg",
      Origin: "India",
    },
    image: serviceimag9,
    servicelink: "/onion"
  },
  {
    id: 8,
    serviceimage: serviceimag10,
    cardtitle: "Honey Mustard / Eucalyptus Honey",
    title: "Honey Mustard / Eucalyptus Honey",
    description: "Premium quality bold Honey Mustard / Eucalyptus Hone for various uses.",
    specifications: {
      Type: "Bold Honey Mustard / Eucalyptus Hone",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: serviceimag10,
    servicelink: "/honey"
  },
  {
    id: 9,
    serviceimage: serviceimag11,
    cardtitle: "Fresh Cavendish G9 Banana",
    title: "Fresh Cavendish G9 Banana",
    description: "Premium quality Fresh Cavendish G9 Bananas for various uses.",
    specifications: {
      Type: "Fresh Cavendish G9 Bananas",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: serviceimag11,
    servicelink: "/banana"
  },
  {
    id: 10,
    serviceimage: serviceimag12,
    cardtitle: "Peanut Butter",
    title: "Peanut Butter",
    description: "Premium quality Peanut Butter for various uses.",
    specifications: {
      Type: "Peanut Butter",
      Color: "light white/creamy",
      Shape: "curve",
      nutCount: "180-190",
      lps: "46,47,48,49,50",
      Minquantity: "1000 kg",
      Origin: "India",
    },
    image: serviceimag12,
    servicelink: "/peanutbutter"
  },
  {
    id: 11,
    serviceimage: serviceimag6,
    cardtitle: "Cummin",
    title: "Cumin",
    description: "Premium quality Cumins for various uses.",
    specifications: {
      taste: "sweet",

      Type: "Cumins",
      form: "gel",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "250g 5kg(client pref), glass bottle jar (client pref)",
      Minquantity: "100 kg",
      Origin: "India",
    },
    image: serviceimag6,
    servicelink: "/cummin"
  },
  {
    id: 11,
    serviceimage: serviceimag7,
    cardtitle: "Cummin",
    title: "Cumin",
    description: "Premium quality Cumins for various uses.",
    specifications: {
      taste: "sweet",

      Type: "Cumins",
      form: "gel",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "250g 5kg(client pref), glass bottle jar (client pref)",
      Minquantity: "100 kg",
      Origin: "India",
    },
    image: serviceimag7,
    servicelink: "/cummin"
  },
  // Repeat for the rest of the products
];


const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
};

export const ProductPage = () => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 768; // Adjust for mobile view
  const productsPerPage = isMobile ? 2 : 4; // 1 for mobile, 4 for larger screens
  const [scrollIndex, setScrollIndex] = useState(0);

  const getVisibleProducts = (scrollIndex, productsPerPage) => {
    const startIndex = scrollIndex % servicesdata.length; // Ensure wrap-around with modulo
    const endIndex = startIndex + productsPerPage;

    return servicesdata.slice(startIndex, endIndex).concat(
      servicesdata.slice(0, Math.max(0, endIndex - servicesdata.length)) // Wrap-around
    );
  };

  // Navigation for next set of products
  const handleNext = () => {
    setScrollIndex((prevIndex) => (prevIndex + productsPerPage) % servicesdata.length);
  };

  // Navigation for previous set of products
  const handlePrev = () => {
    setScrollIndex((prevIndex) => (prevIndex - productsPerPage + servicesdata.length) % servicesdata.length);
  };

  // Get the visible products for the current page
  const visibleProducts = getVisibleProducts(scrollIndex, productsPerPage);

  return (
    <section className="service" id="services">
      <div className="service-container">
        <div className="section-header">
          <h3 className="service-header-title">Our Products</h3>
          <h5>
            "Bringing India's Natural Essence to the World"
          </h5>
          <div className="line-mf"></div>
        </div>
        <div className="product-carousel-container">
          {/* Navigation Buttons */}
          <button
            className="product-carousel-arrow left-arrow"
            onClick={handlePrev}
          >
            &#10094;
          </button>

          {/* Product Cards */}
          <div className="product-carousel">
            {/* Manually render each product */}
            {visibleProducts[0] && (
              <ProductCard
                servicelink={visibleProducts[0].servicelink}
                cardtitle={visibleProducts[0].cardtitle}
                serviceimage={visibleProducts[0].serviceimage}
              />
            )}
            {visibleProducts[1] && (
              <ProductCard
                servicelink={visibleProducts[1].servicelink}
                cardtitle={visibleProducts[1].cardtitle}
                serviceimage={visibleProducts[1].serviceimage}
              />
            )}
            {visibleProducts[2] && (
              <ProductCard
                servicelink={visibleProducts[2].servicelink}
                cardtitle={visibleProducts[2].cardtitle}
                serviceimage={visibleProducts[2].serviceimage}
              />
            )}
            {visibleProducts[3] && (
              <ProductCard
                servicelink={visibleProducts[3].servicelink}
                cardtitle={visibleProducts[3].cardtitle}
                serviceimage={visibleProducts[3].serviceimage}
              />
            )}
            {visibleProducts[4] && (
              <ProductCard
                servicelink={visibleProducts[4].servicelink}
                cardtitle={visibleProducts[4].cardtitle}
                serviceimage={visibleProducts[4].serviceimage}
              />
            )}
            {visibleProducts[5] && (
              <ProductCard
                servicelink={visibleProducts[5].servicelink}
                cardtitle={visibleProducts[5].cardtitle}
                serviceimage={visibleProducts[5].serviceimage}
              />
            )}
            {visibleProducts[6] && (
              <ProductCard
                servicelink={visibleProducts[6].servicelink}
                cardtitle={visibleProducts[6].cardtitle}
                serviceimage={visibleProducts[6].serviceimage}
              />
            )}
            {visibleProducts[7] && (
              <ProductCard
                servicelink={visibleProducts[7].servicelink}
                cardtitle={visibleProducts[7].cardtitle}
                serviceimage={visibleProducts[7].serviceimage}
              />
            )}
            {visibleProducts[8] && (
              <ProductCard
                servicelink={visibleProducts[8].servicelink}
                cardtitle={visibleProducts[8].cardtitle}
                serviceimage={visibleProducts[8].serviceimage}
              />
            )}
            {visibleProducts[9] && (
              <ProductCard
                servicelink={visibleProducts[9].servicelink}
                cardtitle={visibleProducts[9].cardtitle}
                serviceimage={visibleProducts[9].serviceimage}
              />
            )}
            {visibleProducts[10] && (
              <ProductCard
                servicelink={visibleProducts[10].servicelink}
                cardtitle={visibleProducts[10].cardtitle}
                serviceimage={visibleProducts[10].serviceimage}
              />
            )}
            {visibleProducts[11] && (
              <ProductCard
                servicelink={visibleProducts[11].servicelink}
                cardtitle={visibleProducts[11].cardtitle}
                serviceimage={visibleProducts[11].serviceimage}
              />
            )}
            {visibleProducts[12] && (
              <ProductCard
                servicelink={visibleProducts[12].servicelink}
                cardtitle={visibleProducts[12].cardtitle}
                serviceimage={visibleProducts[12].serviceimage}
              />
            )}
          </div>

          <button
            className="product-carousel-arrow right-arrow"
            onClick={handleNext}
          >
            &#10095;
          </button>
        </div>
      </div>
    </section>
  );
};
